<template>
  <div ref="dom" @click="getProjectBoxCellWithAlarm()"></div>
</template>

<script>
import { LevelsShow } from "./LevelsShow/LevelsShow";
import API from "@/api/webgl";
// import cfg from "./config.js";
let levelsShowIns;
export default {
  props: ["alldata", "cellObjShow"],
  data() {
    return {
      modeInfo: {}
    };
  },
  created() {},
  async mounted() {
    levelsShowIns = new LevelsShow();
    this.$refs.dom.appendChild(levelsShowIns.dom);
    levelsShowIns.engine.resize();
    // await levelsShowIns.addglb();
    levelsShowIns.render();
    levelsShowIns.eventbus.$on('objectMouseOver', (e) => {
      this.$emit('mouseover', e);
    });
    levelsShowIns.eventbus.$on('objectClick', (e) => {
      this.modeInfo = e;
    });
  },
  watch: {
    alldata(newvalue, oldvalue) {
      if (oldvalue.id) {
        if (newvalue.id !== oldvalue.id) {
          levelsShowIns.switchProject(newvalue);
        } else {
          levelsShowIns.setData(newvalue);
        }
      } else {
        levelsShowIns.switchProject(newvalue);
      }
    },
  },
  methods: {
    async getProjectBoxCellWithAlarm() {
      if (!this.cellObjShow) {
        this.modeInfo = undefined;
        return false;
      }
      if (this.modeInfo) {
      let params = {}
        params.projectId = levelsShowIns.activeIn.lastmesh.$objinfo.meta.projectId;
        params.sn = levelsShowIns.activeIn.lastmesh.$objinfo.meta.sn;
        params.stackNum = levelsShowIns.activeIn.lastmesh.$objinfo.meta.stackNum;
        params.cluNum = this.modeInfo.cu.cluName;
        params.boxNum = this.modeInfo.name;
        let res = await API.getProjectBoxCellWithAlarm(params);
        if (res.data.code == 200 && !res.data.errors) {
          let batteryData = res.data.data;
		  if(params.boxNum=='高压箱'){
			  batteryData.gao = true
		  }else{
			  batteryData.gao = false
		  }
          this.$emit("batteryData", batteryData);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/canvas.vue